import { RecipientSearch } from '../../models/recipient-search.model';

export interface RecipientSearchSlice {
    readonly recipients: RecipientSearch[];
    readonly selectedRecipient: RecipientSearch | null;
}

export const initialRecipientSearchSlice: RecipientSearchSlice = {
    recipients: [],
    selectedRecipient: null
};
